// Las columnas de la tabla de pedidos de venta.
//
// Vive aparte del componente porque es DATO y no pintura: así se puede importar
// desde un test sin arrastrar medio navegador (vitest corre en `node`). Es el
// mismo reparto que ya usa cargas de salida con `columnasCargaSalida`.
//
// OJO: esta lista manda en la cabecera y en el pie de totales, pero el CUERPO
// de la tabla se pinta A MANO, celda a celda y en este mismo orden. Añadir una
// columna son dos sitios, y el tercero es `TOTAL_COLS` en `formato.ts`, que lo
// amarra un test porque olvidarlo no da error.
import type { PedidoVentaSortKey } from '@/types'

interface PvCol {
  key: string
  labelKey?: string
  sortKey?: PedidoVentaSortKey
  align?: 'right'
  onlyEmpresaAll?: boolean
}

export const COLS: PvCol[] = [
  // El canalón de marcas es una columna más de la rejilla: va aquí para que la
  // cabecera y el pie de totales la cuenten sin tener que sumarle uno a mano.
  { key: 'marca' },
  { key: 'expand' },
  { key: 'docs',             labelKey: 'salesOrders.col.docs' },
  { key: 'salesid',          labelKey: 'salesOrders.col.orderId',      sortKey: 'salesid' },
  { key: 'dataareaid',       labelKey: 'salesOrders.col.company',      onlyEmpresaAll: true },
  { key: 'nombreCliente',    labelKey: 'salesOrders.col.customer',     sortKey: 'nombreCliente' },
  { key: 'customerRef',      labelKey: 'salesOrders.col.customerRef',  sortKey: 'customerRef' },
  { key: 'grupoCliente',     labelKey: 'salesOrders.col.customerGroup' },
  { key: 'salesstatus',      labelKey: 'salesOrders.col.status',       sortKey: 'salesstatus' },
  { key: 'fechaPedido',      labelKey: 'salesOrders.col.orderDate',    sortKey: 'fechaPedido',      align: 'right' },
  { key: 'fechaEntrega',     labelKey: 'salesOrders.col.deliveryDate', sortKey: 'fechaEntrega',     align: 'right' },
  { key: 'importeTotal',     labelKey: 'salesOrders.col.amount',       sortKey: 'importeTotal',     align: 'right' },
  { key: 'importePendiente', labelKey: 'salesOrders.col.pendingAmount', sortKey: 'importePendiente', align: 'right' },
  { key: 'actions',          labelKey: 'salesOrders.col.actions',      align: 'right' },
]

